/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, verticalAlign, fullWidthContent, children }) {
  const isTopAligned = verticalAlign === "top";
  const shouldUseFullWidth = fullWidthContent || isTopAligned;

  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        verticalAlign,
      })}
    >
      <MDBox
        display="inline-block"
        width={shouldUseFullWidth ? "100%" : "max-content"}
        color="text"
        sx={{
          verticalAlign,
          maxWidth: shouldUseFullWidth ? "100%" : undefined,
          whiteSpace: shouldUseFullWidth ? "normal" : undefined,
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  verticalAlign: "middle",
  fullWidthContent: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  verticalAlign: PropTypes.oneOf(["top", "middle", "bottom", "baseline"]),
  fullWidthContent: PropTypes.bool,
};

export default DataTableBodyCell;
